import { ArrowCircleRightSharp } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { MasterContext, UserContext } from "../../ContextApi/context";
import PopUpOneLine from "../../DTechComp/PopUpOneLine";
import PopUpRegular from "../../DTechComp/PopUpRegular";
import utilsCodes from "../../_Utils/utilsCodes";
import utilsUsers from "../../_Utils/utilsUsers";
import PopUpPhoneCheckCode from "../../DTechComp/PopUpPhoneCheckCode";
import TopBigSlides from "../../DTechComp/TopBigSlides";
import PopUpMsg from "../../DTechComp/PopUpMsg";
import { Helmet } from "react-helmet";
import ConnUrls from "../../Connections/ConnectURL";
import PopUpClearComp from "../../DTechComp/PopUpClearComp";
import PopUpHappy from "../../DTechComp/PopUpHappy";
import PopUpsSlides from "../../DTechComp/PopUpsSlides";
import "./MyProfile.css";


const MyDetails = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);

    const [theUser, setTheUser] = useState();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");

    const [readIt, setReadIt] = useState(false);
    const [cardToks, setCardToks] = useState([]);
    const [showCardsPopup, setShowCardsPopup] = useState(false);
    const [thePopUp, setThePopUp] = useState("");


    const history = useHistory();
    // const [topSlides, setTopSlides] = useState();

    const [theErrors, setTheErrors] = useState("");
    const [errorsTxts, setErrorsTxts] = useState("");


    let jumcodeChek = 0;
    let tryLoop = -1;

    useEffect(() => {
        UserEffectFunction();
    }, [])

    useEffect(() => {

        if (user != null && user._id != null) {
            props.scrollToTop();
            props.shoTopStrp(false)

            uploadTheUser();
        }
        else {
            history.push("./")
        }

    }, [user])


    const goToBack = () => {
        history.goBack();

        // if (document.referrer.indexOf(window.location.host) === -1) {
        // }
        // else {
        //      history.push('/'); }
    }

    const uploadTheUser = async () => {
        setFirstName(user?.firstName)
        setLastName(user?.lastName)
        setEmail(user?.email)
        setPhone(user?.phone)
        setPassword(user?.password)
        setReadIt(user?.readIt)
        const toks = await utilsUsers.checkForUserTokensCC(user._id);
        setCardToks(Array.isArray(toks) ? toks : []);
    }

    const removeCard = async (tok) => {
        await utilsUsers.removeCCTok(user._id, tok);
        const updated = await utilsUsers.checkForUserTokensCC(user._id);
        setCardToks(Array.isArray(updated) ? updated : []);
    };

    const removeMeFromSite = () => {
        history.push("/unsubscribe")
    }

    const updateUser = () => {

        let stopMe = false;
        let thEr = "";
        let errs = "";
        if (firstName?.trim().length <= 1) {
            thEr = "firstName";
            errs = (errs === "") ? "יש להזין שם פרטי תקין" : errs;
        }
        if (lastName?.trim().length <= 1) {
            thEr += ",lastName";
            errs = (errs === "") ? "יש להזין שם משפחה תקין" : errs;
        }
        if (!validPhone()) {
            thEr += ",phone";
            errs = (errs === "") ? "יש להזין מספר טלפון תקין" : errs;

        }
        if (!validEmail()) {
            thEr += ",email";
            errs = (errs === "") ? "יש להזין כתובת מייל חוקית" : errs;
        }
        // if (!validPassword()) {
        //     thEr += ",password";
        //     errs = (errs === "") ? "יש להזין סיסמא חזקה יותר.\n על הסיסמא להכיל מינמום 6 תווים, אות גדולה באנגלית, אות קטנה באנגלית ותו מיוחד ( לדוגמא: ! או $) " : errs;
        // }
        if (!readIt) {
            thEr += ",readIt";
            errs = (errs === "") ? "יש לאשר את קריאת התקנון" : errs;
        }

        if (thEr === "") {
            updateUserApply();
        }

        setTheErrors(thEr)
        setErrorsTxts(errs)

    }

    const updateUserApply = async () => {
        tryLoop++;
        let userToUp = { firstName, lastName, phone, email, password, readIt, tryLoop, _id: user._id }
        let codeReply = await utilsCodes.createCodeUpUser(userToUp);

        if (codeReply.errormsg !== null && codeReply.errormsg !== undefined) {
            setErrorsTxts(codeReply.errormsg);
            setThePopUp();
            if (codeReply.loopUp == true) setPhone("");
        }
        else {
            jumcodeChek++;
            let errMsg = (codeReply.errormsg !== undefined) ? codeReply.errormsg : "";

            setThePopUp(
                <PopUpPhoneCheckCode key={jumcodeChek} Title={["אימות פרטים"]}
                    topTitle={"אימות פרטים"}
                    cssStyl={`onTopOfAll`}
                    // topSlides={<TopBigSlides TopImages={[{ img: master.codeSMSImg, txt: "" }]} />}

                    ContentText={["ברגעים אלו נשלח אליך קוד לטלפון", "נא להקיש את הקוד"]}
                    placeholdTxtF={"קוד לבדיקה"}
                    inLabel={""}
                    okClick={(codeCheck) => checkForCode(codeCheck, codeReply.nId)}
                    cancelClick={() => setThePopUp()}
                    recreateCode={() => updateUserApply()}
                    showError={errMsg !== ""}
                    errorMsg={errMsg}
                />

            )
        }
    }

    const checkForCode = async (codeCheck, nId) => {
        let upUser = { firstName, lastName, phone, email, password, readIt, tryLoop, _id: user._id }
        let codeReply = await utilsCodes.checkUpdteCode(nId, { codeCheck, upUser });

        if (codeReply.errMsg !== null) {
            jumcodeChek++;
            setThePopUp(
                <PopUpPhoneCheckCode key={jumcodeChek}
                    topTitle={"אימות פרטים"}
                    Title={["אימות פרטים"]}
                    cssStyl={`onTopOfAll`}
                    topSlides={<TopBigSlides TopImages={[{ img: master.codeSMSImg, txt: "" }]} />}
                    ContentText={["ברגעים אלו נשלח אליך קוד לטלפון", "נא להקיש את הקוד"]}
                    placeholdTxtF={"קוד לבדיקה"}
                    inLabel={""}
                    okClick={(codeCheck) => checkForCode(codeCheck, nId)}
                    cancelClick={() => setThePopUp()}
                    recreateCode={() => updateUserApply()}
                    showError={codeReply.errMsg !== ""}
                    errorMsg={codeReply.errMsg}
                />
            )
        }
        else {
            jumcodeChek++;
            setThePopUp(
                <PopUpClearComp
                    popFullComp={"specialPopComp onTopOfAll"}
                    cssStyl={"noPadding"}
                    btnFStyle={"fatInBtn"}
                    // closePop={() => setThePopUp()}
                    insideCss={"noPadding"}
                    theInsideComp={
                        <PopUpHappy key={jumcodeChek}
                            Title={["הפרטים עודכנו בהצלחה"]}
                            cssStyl={"okPOP onTopOfAll"}
                            topSlides={<PopUpsSlides key={"logInPop"} TopImages={[{ img: master.successUpdate, txt: "" }]} />}
                            ContentText={[]}
                            inLabel={""}
                            okClick={() => setThePopUp()}
                        />

                    } />
            );

            UserEffectFunction();

            setTimeout(() => { setThePopUp() }, 5000)


        }
    }

    const validPhone = () => {
        if (phone !== "") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (!pattern.test(phone)) {
                return false
            } else if (phone.length != 10 && phone.length != 9) {
                return false
            }
            else {
                return true;
            }
        }
    }
    const validEmail = () => {
        if (email !== "") {
            var pattern = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
            if (!pattern.test(email)) {
                return false
            }
            else {
                return true;
            }
        }
    }

    const validPassword = () => {
        if (password !== "") {
            let pattern = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{6,}))');
            if (!pattern.test(password)) {
                return false
            }
            else {
                return true;
            }
        }
    }

    return (
        <div className={"loginPage"}>
              <div className={"headOnFixC2 centerText bold big"}>
                פרטי משתמש
                <div className={`backSdOnlyBtn`}>
                    <ArrowCircleRightSharp onClick={() => goToBack()} />
                </div>
            </div>
            <br /><br /><br /><br />

            <div className={"profilePage"}>
                <div className={"profileScreen"}>

                    <div className={"profileHeader"}>
                        <p className={"profileHeaderName"}>{firstName} {lastName}</p>
                        <p className={"profileHeaderMeta"}>{email}</p>
                    </div>

                    <div className={"detailsCard"}>

                        {(theErrors !== "" || errorsTxts !== "") &&
                            <div className={"detailsErrorMsg"}>
                                {(!theErrors.includes("firstName") && !theErrors.includes("lastName") && errorsTxts !== "")
                                    ? `- ${errorsTxts}`
                                    : theErrors !== "" ? "כל התאים המסומנים הינם חובה" : `- ${errorsTxts}`
                                }
                            </div>
                        }

                        <div className={"detailsInputRow"}>
                            <input type={"text"} className={`detailsInput${theErrors.includes("firstName") ? " detailsInput--error" : ""}`} value={firstName} placeholder={"שם פרטי"} onChange={(e) => setFirstName(e.target.value)} />
                        </div>

                        <div className={"detailsInputRow"}>
                            <input type={"text"} className={`detailsInput${theErrors.includes("lastName") ? " detailsInput--error" : ""}`} value={lastName} placeholder={"שם משפחה"} onChange={(e) => setLastName(e.target.value)} />
                        </div>

                        <div className={"detailsInputRow"}>
                            <input type={"text"} className={`detailsInput${theErrors.includes("phone") ? " detailsInput--error" : ""}`} value={phone} placeholder={"טלפון נייד (לקבלת SMS)"} onChange={(e) => setPhone(e.target.value)} />
                        </div>

                        <div className={"detailsInputRow"}>
                            <input type={"text"} className={`detailsInput${theErrors.includes("email") ? " detailsInput--error" : ""}`} value={email} placeholder={"אימייל"} onChange={(e) => setEmail(e.target.value)} autoComplete="off" />
                        </div>

                        {/* <div className={"detailsInputRow"}>
                            <input type={"password"} className={`detailsInput${theErrors.includes("password") ? " detailsInput--error" : ""}`} value={password} placeholder={"סיסמא"} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
                        </div> */}

                        <div className={`detailsTermsRow${theErrors.includes("readIt") ? " detailsInput--error" : ""}`}>
                            <Checkbox checked={readIt} onChange={() => setReadIt(!readIt)} className="chkBx" />
                            <div className={"readItTxt"}>
                                <span>קראתי ואני מסכים/ה לתנאי </span>
                                <Link className={"readItLink"} to={"/TAkanon"}>התקנון</Link>
                            </div>
                        </div>

                    </div>

                    <div className={"profileMenuList detailsCardsRow"}>
                        <div className={"profileMenuItem"} onClick={() => setShowCardsPopup(true)}>
                            <div className={"profileMenuIcon profileMenuIcon--blue"}>💳</div>
                            <div className={"profileMenuText"}>
                                <p className={"profileMenuTitle"}>אמצעי תשלום</p>
                                {cardToks.length > 0 &&
                                    <p className={"profileMenuSubtitle"}>כרטיס מסתיים ב-{cardToks[cardToks.length - 1].Last4CardDigits}</p>
                                }
                            </div>
                            <span className={"profileMenuArrow"}>›</span>
                        </div>
                    </div>

                    <div className={"profileFooter"}>
                        <button className={"detailsUpdateBtn"} onClick={() => updateUser()}>עדכן פרטים</button>
                        <button className={"detailsDeleteBtn"} onClick={() => removeMeFromSite()}>מחק אותי מהאתר</button>
                    </div>

                </div>
            </div>

            {showCardsPopup && (
                <PopUpClearComp
                    popFullComp={"specialPopComp onTopOfAll"}
                    cssStyl={"noPadding"}
                    closePop={() => setShowCardsPopup(false)}
                    insideCss={"noPadding"}
                    theInsideComp={
                        <div className={"cardsPopupContent"}>
                            <div className={"cardsPopupHeader"}>
                                <span className={"cardsPopupTitle"}>אמצעי תשלום</span>
                                <button className={"cardsPopupClose"} onClick={() => setShowCardsPopup(false)}>✕</button>
                            </div>
                            <div className={"cardsPopupList"}>
                                {cardToks.length === 0 ? (
                                    <p className={"cardsPopupEmpty"}>אין כרטיסים שמורים</p>
                                ) : (
                                    cardToks.map((card, i) => (
                                        <div key={i} className={"cardsPopupItem"}>
                                            <div className={"cardsPopupItemInfo"}>
                                                <span className={"cardsPopupCardNum"}>💳 ****-{card.Last4CardDigits}</span>
                                            </div>
                                            <button className={"cardsPopupRemoveBtn"} onClick={() => removeCard(card.Token)}>הסר</button>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    }
                />
            )}
            {thePopUp}
            <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/MyDetails`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/MyDetails`} />
            </Helmet>
        </div>
    )

}

export default MyDetails